import { classNames, prettyValue } from "~/lib/util";

export type Transaction = {
  trade_id: string;
  price: number;
  base_volume: number;
  quote_volume: number;
  trade_timestamp: number;
  type: "buy" | "sell";
};

export function RecentTransactions({ transactions, baseTokenSymbol, quoteTokenSymbol }: { transactions: Transaction[]; baseTokenSymbol: string; quoteTokenSymbol: string }) {
  if (!transactions || transactions.length === 0) {
    return <p className="text-sm text-gray-500">No recent transactions.</p>;
  }

  return (
    <div className="flow-root">
      <ul role="list" className="-my-5 divide-y divide-gray-200 dark:divide-gray-700">
        {transactions.map((tx) => (
          <li key={tx.trade_id} className="py-4">
            <div className="flex items-center space-x-4">
              <div className="min-w-0 flex-1">
                <p className={classNames(tx.type === "buy" ? "text-green-600" : "text-red-600", "truncate text-sm font-medium")}>
                  {tx.type === "buy" ? "Buy" : "Sell"} {baseTokenSymbol}
                </p>
                <p className="truncate text-xs text-gray-500">
                  {new Date(tx.trade_timestamp).toLocaleString()}
                </p>
              </div>
              <div className="text-right text-sm">
                <div className="font-medium text-gray-900 dark:text-gray-100">
                  {prettyValue(tx.base_volume)} {baseTokenSymbol}
                </div>
                <div className="text-gray-500">
                  {prettyValue(tx.quote_volume)} {quoteTokenSymbol}
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
